import { createAction } from '@ngrx/store';

/**
 * Action to return an empty action.
 */
export const RETURN_EMPTY = createAction('[Utils]Return EMPTY ACTION');